"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.databaseProjectionColumns = databaseProjectionColumns;
exports.databaseProjectionViewState = databaseProjectionViewState;
const database_projection_1 = require("./database-projection");
const index_1 = require("./index");
const record = (value) => value && typeof value === 'object' && !Array.isArray(value)
    ? value
    : {};
/** Serial adapters for existing built-in property metadata, without renderer imports. */
function databaseProjectionColumns(input, options = {}) {
    // Split database roots persist ordinary columns only. The native title is
    // structural, just as in the DataSource and backend split-root reader.
    const columns = options.structuralTitle &&
        !input.some(column => column.type === 'title' || column.id === 'title')
        ? [{ id: 'title', name: 'Title', type: 'title', data: {} }, ...input]
        : input;
    const virtualColumns = index_1.DATABASE_ROW_SYSTEM_FIELD_IDS.filter(id => !columns.some(column => column.id === id)).map(id => ({
        id,
        type: id,
        name: index_1.DATABASE_ROW_SYSTEM_FIELD_NAMES[id],
        data: {},
    }));
    return [...columns, ...virtualColumns].map(column => {
        const data = column.data ?? {};
        const names = {
            text: 'String',
            title: 'RichText',
            'rich-text': 'RichText',
            number: 'Number',
            progress: 'Number',
            date: 'Date',
            'created-time': 'Date',
            'updated-time': 'Date',
            'created-by': 'User',
            'updated-by': 'User',
            checkbox: 'Boolean',
            select: 'Tag',
            'multi-select': 'array',
            link: 'String',
            'doc-reference': 'String',
            relation: 'array',
            member: 'array',
            url: 'URL',
            image: 'Image',
            attachment: 'Attachment',
        };
        // The items of a list, as the cells of the table view hold them.
        const elements = {
            'multi-select': 'Tag',
            relation: 'String',
            member: 'User',
        };
        const name = names[column.type];
        const element = elements[column.type];
        const logicalType = name
            ? {
                name,
                data: name === 'Tag' ? (data.options ?? []) : null,
                ...(element ? { element: { name: element } } : {}),
            }
            : null;
        const result = { ...column, data, logicalType };
        (0, database_projection_1.assertDatabaseProjectionSerializable)(result);
        return result;
    });
}
/** Group settings belong to the same view in the same root snapshot. */
function databaseProjectionViewState(views, viewId) {
    const view = record(views.find(value => record(value).id === viewId));
    const groups = [];
    for (const [field, propertiesField] of [
        ['groupBy', 'groupProperties'],
        ['groupBy2', 'groupProperties2'],
    ]) {
        const group = record(view[field]);
        if (typeof group.columnId !== 'string' || typeof group.name !== 'string')
            continue;
        const sort = record(group.sort);
        const properties = Array.isArray(view[propertiesField])
            ? view[propertiesField]
            : [];
        groups.push({
            columnId: group.columnId,
            name: group.name,
            sortMode: group.sort ? (sort.desc ? 'desc' : 'asc') : 'default',
            properties: properties.map(value => {
                const property = record(value);
                return {
                    key: String(property.key ?? ''),
                    hide: !!property.hide,
                    manuallyCardSort: Array.isArray(property.manuallyCardSort)
                        ? property.manuallyCardSort.filter((id) => typeof id === 'string')
                        : [],
                };
            }),
        });
    }
    const result = { groups };
    (0, database_projection_1.assertDatabaseProjectionSerializable)(result);
    return result;
}
